module.exports = __webpack_public_path__ + "img/转圈.4baa7be0.gif";